import React from 'react';
import ErrorBoundaries from '../../../components/ErrorBoundaries';
import EinstellungenSeitenKopf from '../components';
import AllBookingAccountsTable from './components/AllBookingAccountsTable';

function OptionsPage() {
  return (
    <>
      <EinstellungenSeitenKopf title="Buchungskonten" />
      <ErrorBoundaries>
        <AllBookingAccountsTable />
      </ErrorBoundaries>
    </>
  );
}

export default OptionsPage;
